// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__566PG","amount":"Amount_amount__3O1on","tip":"Amount_tip__3_BbY","tipHeader":"Amount_tipHeader__3zSiP","tipsWrap":"Amount_tipsWrap__1dp1Q"};